module.exports = __webpack_public_path__ + "img/subscription-contract.b4f93af2.svg";